module.exports = __webpack_public_path__ + "public/images/generated-calculus.14a1938ba6964e1d768e8777626ccc00.jpg";